import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mobile/copy-text-icon.png'
import _imports_1 from '@/assets/images/mobile/gift-icon.svg'
import _imports_2 from '@/assets/images/mobile/close-share-d-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-4ebc2fb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-dialog" }
const _hoisted_2 = { class: "first-page-container bg-white p-3 rounded-3 position-relative" }
const _hoisted_3 = { class: "dashed-container rounded-3 d-flex flex-column align-items-center px-1 position-relative" }
const _hoisted_4 = { class: "text-black mt-3 fs-6" }
const _hoisted_5 = { class: "code text-black mt-1 fw-semibold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "copy",
  class: "copy-text-icon ms-1"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "gift-package d-flex align-items-start rounded-5 py-2 px-3 mt-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "gift-icon"
}, null, -1))
const _hoisted_10 = { class: "gift-text m-0 ms-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue-circle c1" }, null, -1))
const _hoisted_12 = { class: "btn-group d-flex justify-content-center mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "close"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_share_image_part = _resolveComponent("share-image-part")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString($setup.local.share_link_4), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", { ref: "textToCopy" }, _toDisplayString($setup.props.invCode), 513),
          _createElementVNode("span", {
            role: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.copyCode()))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("p", _hoisted_10, _toDisplayString($setup.local.share_link_55), 1)
        ]),
        _createVNode(_component_share_image_part, { qrId: "qrcode2" }),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "share-btn btn-linkk",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.copyLink()))
          }, _toDisplayString($setup.local.share_6), 1),
          _createElementVNode("button", {
            class: "share-btn btn-image",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.takeImag()))
          }, _toDisplayString($setup.local.share_7), 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.close())),
          class: "position-absolute rounded-circle d-flex align-items-center justify-content-center close-btn border-0"
        }, _hoisted_14)
      ])
    ])
  ]))
}